export default __webpack_public_path__ + "static/media/search-colored.c3fbd1d8.svg";